export const USER_LOGGED_OUT = "user logged out";
export const USER_ADDED_SUCCESSFULLY = "user added successfully!";
export const USER_ALREADY_REGISTERED = "user already registered";
export const VERIFICATION_EMAIL_SENT = "verification email sent";
